<svelte:options customElement={{ tag: "bt-link-button", shadow: "none", }} />

<script lang="ts">
	export let link = '/';
	export let text = '';
  export let design: 'primary' | 'secondary' = 'primary';

	let linkEl: HTMLElement | null = null;

	const handleClick = () => {
		if (linkEl) {
			linkEl.style.pointerEvents = 'none';
		}
	}
</script>


<a class={`link-button link-button--${design}`} href="{link}" bind:this={linkEl} on:click={handleClick}>
		{text}
</a>

<style>
  .link-button {
    white-space: nowrap;
    max-width: theme('screens.sm');
    padding: 0.625rem theme('padding.6');
    font-size: theme('fontSize.sm');
    border-radius: 8px;
    transition: all 100ms ease-in-out;
    &:hover {
    	background: transparent;
    	color: theme('colors.neutral.900');
    }
  }
  .link-button--primary {
    background: theme('colors.neutral.900');
    border: 1px solid theme('colors.neutral.900');
    color: white;
  }
  .link-button--secondary {
    background: white;
    border: 1px solid theme('colors.neutral.300');
    color: black;
    font-weight: 500;
  }
  @media print {
    .link-button {
      display: none !important;
    }
  }
</style>
